module.exports = __webpack_public_path__ + "static/media/left-banner.c8bb092f.jpg";